import { render, staticRenderFns } from "./CheckboxOffIcon.vue?vue&type=template&id=5730155a"
import script from "./CheckboxOffIcon.vue?vue&type=script&lang=ts"
export * from "./CheckboxOffIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports